module.exports = __webpack_public_path__ + "img/banner-suarez-content.0448bbed.png";